import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { HeaderProvider } from "./hooks/context/HeaderContext";
import { LoaderProvider } from "./components/common/LoaderContext";
import Loader from "./pages/Loader";
import { AuthProvider } from "./msal/AuthProvider";
import SSOAuthenticator from "./msal/SSOAuthenticator";
import UserInitializer from "./components/UserInitializer";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <LoaderProvider>
        <HeaderProvider>
          <Router>
            <SSOAuthenticator>
              <UserInitializer />
              <Loader />
              <AppRoutes />
            </SSOAuthenticator>
          </Router>
        </HeaderProvider>
      </LoaderProvider>
    </AuthProvider>
  );
};

export default App;
